// ============================================================================
// routePrefetch — prefetch de chunks de rota ao passar o mouse
// ============================================================================
// O React.lazy só baixa o chunk quando o componente é montado, o que causa
// 1-2s de fallback ao trocar de rota. Pra evitar isso, disparamos `import()`
// já no hover do link da sidebar — quando o user clica, o chunk geralmente
// já chegou.
//
// `import()` é dedupado pelo runtime de módulos (chamadas repetidas
// devolvem a mesma Promise). Então seguro chamar muitas vezes.
// ============================================================================

// Mapa caminho → factory de import. Deve refletir as rotas lazy em App.jsx.
const PREFETCH_MAP = {
  '/gestao/dashboard':       () => import('../pages/admin/Dashboard.jsx'),
  '/gestao/inteligencia':    () => import('../pages/admin/Inteligencia.jsx'),
  '/gestao/meu-desempenho':  () => import('../pages/manager/Dashboard.jsx'),
  '/gestao/profissionais':   () => import('../pages/admin/Professionals.jsx'),
  '/gestao/clientes':        () => import('../pages/admin/Clientes.jsx'),
  '/gestao/agenda':          () => import('../pages/admin/Agenda.jsx'),
  '/gestao/estoque':         () => import('../pages/admin/Estoque.jsx'),
  '/gestao/metas':           () => import('../pages/admin/Goals.jsx'),
  '/gestao/desafios':        () => import('../pages/admin/Challenges.jsx'),
  '/gestao/engajamento':     () => import('../pages/admin/Engagement.jsx'),
  '/gestao/ranking':         () => import('../pages/admin/Ranking.jsx'),
  '/gestao/ranking-unidade': () => import('../pages/admin/RankingUnidade.jsx'),
  '/gestao/aniversarios':    () => import('../pages/Aniversarios.jsx'),
  '/gestao/duelos':          () => import('../pages/Duels.jsx'),
  '/gestao/unidades':        () => import('../pages/admin/Units.jsx'),
  '/gestao/relatorios':      () => import('../pages/admin/Reports.jsx'),
  '/gestao/servicos':        () => import('../pages/admin/Services.jsx'),
  '/gestao/configuracoes':   () => import('../pages/admin/Settings.jsx'),
  '/gestao/avec-debug':      () => import('../pages/admin/AvecDebug.jsx'),
  '/gestao/financeiro':      () => import('../pages/admin/Finance.jsx'),
  '/gestao/auditoria':       () => import('../pages/admin/Auditoria.jsx'),
  '/gestao/usuarios':        () => import('../pages/admin/Usuarios.jsx'),
  '/gestao/atendimento':     () => import('../pages/admin/Atendimento.jsx'),
  '/gestao/avaliacoes':      () => import('../pages/admin/Avaliacoes.jsx'),
  '/gestao/integracoes':     () => import('../pages/admin/Integracoes.jsx'),
  '/gestao/candidatos':      () => import('../pages/admin/Candidatos.jsx'),
  '/gestao/atendimento-ia':   () => import('../pages/admin/atendimento/Simulador.jsx'),
  '/gestao/pre-agendamentos': () => import('../pages/admin/atendimento/PreAgendamentos.jsx'),
  '/gestao/crm-sofia':        () => import('../pages/admin/crm/CrmSofia.jsx'),
  '/gestao/minhas-conquistas': () => import('../pages/professional/MyAchievements.jsx'),
  '/gestao/meta-realizado':  () => import('../pages/admin/Goals.jsx'),
  '/gestao/wrapped':         () => import('../pages/Wrapped.jsx'),
  '/gestao/manual-recepcao': () => import('../pages/ManualRecepcao.jsx'),
};

const triggered = new Set();

/**
 * Dispara prefetch do chunk da rota. Idempotente (cada rota só dispara 1x).
 * Silencia erros — prefetch é best-effort.
 */
export function prefetchRoute(path) {
  if (!path || triggered.has(path)) return;
  const factory = PREFETCH_MAP[path];
  if (!factory) return;
  triggered.add(path);
  factory().catch(() => triggered.delete(path)); // retry permitido se falhou
}
